// extracted by mini-css-extract-plugin
export default {"modalContent":"AddAQuestion_modalContent__yrlLn","footerBtns":"AddAQuestion_footerBtns__h1hQP","modal":"AddAQuestion_modal__ZqXlo","mb24":"AddAQuestion_mb24__thIxv"};